// Utility to build Chart.js histogram data/options from backend binEdges + counts

export function buildHistogramChart(binEdges, countsOrDensity, {
  label = 'Count',
  color = 'rgba(59, 130, 246, 0.6)',
  borderColor = 'rgba(37, 99, 235, 1)',
  density = false,
  xLabel = '',
  yLabel = density ? 'Density' : 'Count',
  showLegend = false
} = {}) {
  if (!Array.isArray(binEdges) || binEdges.length < 2) {
    return {
      data: { labels: [], datasets: [] },
      options: {}
    }
  }

  const values = Array.isArray(countsOrDensity) ? countsOrDensity : []
  const k = Math.max(0, binEdges.length - 1)
  const labels = []
  const data = []

  for (let i = 0; i < k; i++) {
    const left = binEdges[i]
    const right = binEdges[i + 1]
    // Pick label precision based on bin width
    const width = Math.abs(Number(right) - Number(left))
    let dp = 2
    if (width >= 1) dp = 0
    else if (width >= 0.5) dp = 1
    else if (width >= 0.1) dp = 2
    else if (width >= 0.05) dp = 2
    else dp = 3
    labels.push(`${Number(left).toFixed(dp)}–${Number(right).toFixed(dp)}`)
    data.push(Number(values[i] ?? 0))
  }

  const chartData = {
    labels,
    datasets: [
      {
        label,
        data,
        backgroundColor: color,
        borderColor,
        borderWidth: 1,
        categoryPercentage: 1.0,
        barPercentage: 1.0
      }
    ]
  }

  // Plugin to draw percentage labels above bars
  const total = data.reduce((a, b) => a + (isFinite(b) ? b : 0), 0)
  const percentPlugin = {
    id: 'barValueLabels',
    afterDatasetsDraw(chart) {
      const { ctx } = chart
      const dataset = chart.data.datasets[0]
      if (!dataset) return
      const meta = chart.getDatasetMeta(0)
      ctx.save()
      ctx.fillStyle = '#374151'
      ctx.font = '12px sans-serif'
      ctx.textAlign = 'center'
      meta.data.forEach((bar, index) => {
        const value = Number(dataset.data[index] ?? 0)
        const pct = total > 0 ? (value / total) * 100 : 0
        const text = `${pct.toFixed(1)}%`
        const x = bar.x
        const y = bar.y - 4
        ctx.fillText(text, x, y)
      })
      ctx.restore()
    }
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: showLegend },
      tooltip: { enabled: true }
    },
    scales: {
      x: {
        stacked: false,
        title: xLabel ? { display: true, text: xLabel } : undefined
      },
      y: {
        beginAtZero: true,
        stacked: false,
        title: yLabel ? { display: true, text: yLabel } : undefined
      }
    }
  }

  return { data: chartData, options: chartOptions, plugins: [percentPlugin] }
}


